var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottomCenter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 9,
    viewBox: "0 0 15 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1441 9C14.035 9 14.4812 7.92286 13.8512 7.29289L7.78017 1.22182C7.38965 0.831293 6.75648 0.831294 6.36596 1.22182L0.294898 7.29289C-0.335067 7.92286 0.1111 9 1.002 9H13.1441Z",
    fill: "#111827"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomCenter);
export default __webpack_public_path__ + "static/media/bottom-center.150011787fa786142daf546f6d7eba3e.svg";
export { ForwardRef as ReactComponent };